import apiClient from '@/plugins/axios';

export default {
	getFireProtections(params) {
		params.pageNumber = params.currentPage;

		return apiClient.get('v1/FireProtection', { params: params });
	},

	getFireProtection(fireProtectionId) {
		return apiClient.get(`v1/FireProtection/${fireProtectionId}`);
	},

	createFireProtection(fireProtection) {
		return apiClient.post('v1/FireProtection', fireProtection);
	},

	updateFireProtection(fireProtection) {
		var fireProtectionId = fireProtection.id;

		return apiClient.put(
			`v1/FireProtection/${fireProtectionId}`,
			fireProtection
		);
	},

	deleteFireProtection(fireProtectionId) {
		return apiClient.delete(`v1/FireProtection/${fireProtectionId}`);
	}
};
